// extracted by mini-css-extract-plugin
export default {"wrapper":"X8J9y3xHcyewXzNLP27q","dataRow":"n8ciiS2ofHlO8S6lAuhQ","accordionItem":"iIfMOOBaC4bHeIGbhjIA","accordionIcon":"RBBguIYszVwm3s1fyul9","dataRowIcon":"Y9gI18zVPNkioDBl206l"};